import React, { useEffect } from 'react'
import Summary from '../components/DiscussionRoom/summaries/summary';
import DebateUpdate from '../components/DebateRoom/Debate Files/DebateUpdates/DebateUpdate';
import UpdateSummary from '../components/DebateRoom/Debate Files/DebateSummaries/UpdateSummary';
import DebateCommentSection from '../components/DebateRoom/Debate Files/DebateCommentSection';
import Footer from '../layout/Footer';
import DebateRoom from '../components/DebateRoom/Debate Files/DebateRoom';
import { useDispatch, useSelector } from 'react-redux';
import { getEachDebate } from '../redux/Thunks/debatesThunk';
import { useParams } from 'react-router-dom';



const DebateCenter = () => {
  const {debate_id} = useParams()
  const dispatch = useDispatch()
  const debate = useSelector(state => state.debates.oneDebate)

  function fetchCurrentDebate(ID){
    dispatch(
      getEachDebate({
        debate_id : ID
      })
    )
  }


  useEffect(() => {
    fetchCurrentDebate(debate_id)

    // eslint-disable-next-line 
  }, [dispatch, debate_id])
  return (
    <div className='bg-nightModeDark text-white min-h-max'>
    <div className='flex flex-col lg:flex-row gap-4 m-1 md:m-4'>
    {debate ?
      <DebateRoom
      debateDetails={debate}
    />
    :
    <div 
    className='flex flex-col justify-center items-center bg-[#202020] text-white 
                    w-full h-[70vh] lg:w-2/3 rounded-lg'>
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-[#3C6E71]"></div>
      <p className='text-center'>Loading Debate Details</p>
    </div>
    }
    <Summary/>
    </div>

    <div className='flex flex-col lg:flex-row gap-4 mx-1 my-2 md:m-4'>
      <DebateUpdate debateData={debate} debate_id={debate_id} />
      {/* <Opinion/> */}
      <UpdateSummary/>
    </div>
      <DebateCommentSection/>
      <Footer/>
    </div>
  )
}

export default DebateCenter;